export default (storeState, {payload}) => {
  let newState = Object.assign({}, storeState);

  newState.asideData = payload

  return newState;
};
